
import { ElMessage } from "element-plus";
import { getMenuTree } from "@/api/index";

import { useStore } from "vuex";
import { ElForm ,ElTree  } from "element-plus";
import type Node from 'element-plus/es/components/tree/src/model/node';
import { putRole , getRoleDetail, updRole} from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增枚举",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();


    const defaultProps = {
      children: 'children',
      label: 'menuName',
    };
    const dataMap: any = reactive({
      treeRef:ref<InstanceType<typeof ElTree>>(),
      data : [],
      ruleForm: {
        menuIds: [],
        roleName: "",
        description: "",
        roleCode: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名", trigger: "blur" },
        ],
        roleCode: [
          { required: true, message: "请输入角色编码", trigger: "blur" },
        ],
        menuIds: [
          { required: true, message: "请设置角色菜单权限", trigger: "blur" },
        ],
      },

      async putRole() {
        const res = await putRole(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },

      async updRole() {
        const res = await updRole(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      

      async getMenus(){
        const res = await getMenuTree('MENU_CLASSFIER_BACKSTAGE');
         if(res.code===200) dataMap.data = res.data;
      },
      setCheckedKey: (ids: any) => {
        dataMap.treeRef.setCheckedKeys(ids, false);
       },
      async getDetail(id: any){
        const res = await getRoleDetail(id);
         if(res.code===200){
            dataMap.ruleForm  = res.data;
            dataMap.setCheckedKey(dataMap.ruleForm.menuIds);
          }
      },

     
    });

    if (opt.row) {
      isEdit = true;
      dataMap.getDetail(opt.row.id);
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          isEdit ?  dataMap.updRole() : dataMap.putRole();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };
 
    const getNodes =() =>{
      dataMap.ruleForm.menuIds = dataMap.treeRef.getCheckedKeys(false);
    };


   

    onMounted(() => {
      dataMap.getMenus();
    });

    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      defaultProps,
      close,
 
      getNodes,
      ...toRefs(dataMap),
    };
  },
});
